import { configureStore } from '@reduxjs/toolkit';
import authReducer from "../redux/slices/authSlice";
import categorySliceReducer from "../redux/slices/categorySlice";
import userSliceReducer from "../redux/slices/userSlice";
import blogSliceReducer from "../redux/slices/blogslice";
import siteDetailReducer from "../redux/slices/siteDetailSlice";
import contactReducer from "../redux/slices/contactSlice";
import pageReducer from "../redux/slices/pageSlice"


const store = configureStore({

  reducer: {
    auth: authReducer,
    categories: categorySliceReducer,
    users: userSliceReducer,
    blogs: blogSliceReducer,
    siteDetail: siteDetailReducer,
    contact: contactReducer,
    page: pageReducer
  },

});

export default store;
